import React, { useEffect, useState } from 'react'
import emailBanner from '../../../../media/images/banner.svg'
import { useNavigate, useSearchParams } from 'react-router-dom';
import { acceptInvite } from '../../compliance-meeting/core/_requests';
import Skeleton from 'react-loading-skeleton';
import { useIntl } from 'react-intl';

export const MeetingInvite = () => {
  const { formatMessage } = useIntl()
  const [updated, setUpdated] = useState(false)
  const [search] = useSearchParams();
  const navigate = useNavigate()
  const meetingId = search.get('meetingId');
  const participantId = search.get('participantId');
  const status = search.get('status');
  useEffect(() => {
    const acceptInvited = async () => {
      if (meetingId && participantId && status) {
        try {
          const { data: { success } } = await acceptInvite(meetingId, participantId, status);
          if (success) {
            setUpdated(true)
          } else {
            navigate('/auth/login')
          }
        } catch (error) {
          navigate('/auth/login')
        }
      }
    };
    acceptInvited();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <>
      {!updated ?
        <Skeleton
          height={200}
          baseColor='var(--kt-skeleton-bg-color)'
          highlightColor='var(--kt-skeleton-highlight-bg-color)'
        />
        :
        <div className='pb-11'>
          <div className='m-20 d-flex flex-column justify-content-center align-items-center'>
            <img src={emailBanner} alt='banner' height={240} width={360} className='d-flex flex-column w-100 justify-content-center' />
            <p className='mt-5 mx-20 text-center'>
              {formatMessage({
                id: `Thank you for your response. Your response has been taken on record. You can change
              it at anytime by clicking on the response button in meeting invite email.`})}
            </p>
          </div>
        </div>
      }
    </>
  )
}